import { Toast } from "antd-mobile";
import React from "react";
import { useTranslation } from "react-i18next";
import { useAuth } from "../../../../context/AuthContext";
import { getCurrency } from "../../../../plugins/utils";
import CustomRadioList from "../../../CustomRadioList";
import { useGetCurrency } from "../../hooks/currency.hook";

const CurrencyChangerContent = ({ customOnChangeEvent }) => {
  const { t } = useTranslation();
  const { setDefaultCurrency, queryToken } = useAuth();
  const nowCurrency = getCurrency();
  const getCurrencyList = useGetCurrency({
    options: {
      enabled: !!queryToken === false,
    },
  });
  return (
    <CustomRadioList
      defaultValue={nowCurrency}
      radioItems={getCurrencyList.data}
      onChange={(val) => {
        if (customOnChangeEvent) {
          customOnChangeEvent(val);
          return;
        }
        setDefaultCurrency(val);
        Toast.show({
          icon: "success",
          content: t("mobile.personal.menu.currency.set"),
        });
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      }}
    />
  );
};

export default CurrencyChangerContent;
